/* eslint-disable no-undef */

// Polyfill for forEach ES6.
if ( window.NodeList && ! NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

jQuery( function( $ ) {
	// Components
	$( '.faq-read-more' ).on( 'click', function() {
		const id = $( this ).attr( 'id' );
		$( '#faq-excerpt-' + id ).toggle();
		$( '#faq-content-' + id ).toggle();
		$( this ).text( function( i, text ) {
			return ankarsrumI18n.read_less === text ? ankarsrumI18n.read_more : ankarsrumI18n.read_less;
		} );
	} );

	// When selecting a lang. set a cookie. Used by CloudFlare worker.
	$( '.btn-aclp' ).on( 'click', function() {
		setCookie( 'aclp', 'true', 14 );
	} );

	function setCookie( name, value, days ) {
		const d = new Date;
		// eslint-disable-next-line no-mixed-operators
		d.setTime( d.getTime() + 24 * 60 * 60 * 1000 * days );
		document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
	}

	/**
	 * Only show wave line when scroll is top.
	 */
	$( window ).scroll( function() {
		// eslint-disable-next-line no-mixed-operators
		$( '.header-double-line' ).css( 'opacity', 1 - $( window ).scrollTop() / 40 );
	} );

	$( '.img-txt-block-left .square-play-icon.play-circle' ).on( 'click', function() {
		$( this ).parent().find( '.hero-popup-video' )[ 0 ].click();
	} );

	if ( $( '.hero-block' ).length ) {
		$( '.hero-block' ).css( {
			//Height of newsletter container - add to cart banner - header
			'margin-top': -$( '.site-header' ).outerHeight( true ),
			'padding-top': $( '.site-header' ).outerHeight( true ) + 20,
		} );
		$( window ).resize( function() {
			$( '.hero-block' ).css( {
				//Height of newsletter container - add to cart banner - header
				'margin-top': -$( '.site-header' ).outerHeight( true ),
				'padding-top': $( '.site-header' ).outerHeight( true ) + 20,
			} );
		} );

		$( '.site-header' ).addClass( 'transparent-header' );
		$( window ).scroll( function() {
			const scroll = $( window ).scrollTop();
			if ( 20 <= scroll ) {
				//clearHeader, not clearheader - caps H
				$( '.site-header' ).removeClass( 'transparent-header' );
			} else {
				$( '.site-header' ).addClass( 'transparent-header' );
			}
		} );

		if ( $( '.hero-block.light' ).length ) {
			$( '.site-header' ).addClass( 'transparent-header-light' );
			$( window ).scroll( function() {
				const scroll = $( window ).scrollTop();
				if ( $( '.site-header' ).outerHeight( true ) <= scroll ) {
					//clearHeader, not clearheader - caps H
					$( '.site-header' ).removeClass( 'transparent-header-light' );
				} else {
					$( '.site-header' ).addClass( 'transparent-header-light' );
				}
			} );
		}

		const video = $( '.hero-video' );
		const videoElement = video.get( 0 );
		if ( videoElement ) {
			$( '.hero-block' ).css( 'background-image', 'none' );
		}
	}

	$( '.product-meta-link-info' ).on( 'click', function() {
		$( '.product-block-description' ).removeClass( 'accordion-hidden' );
	} );

	$( window ).on( 'load', function() {
		$( '.product-image-slider' ).on( 'click', function() {
			if ( $( '.product-video-slider-item-thumb' ).hasClass( 'swiper-slide-active' ) ) {
				const anchor = document.querySelector( '.video-trigger-click' );
				if ( null === anchor ) {
					return;
				}
				anchor.click();
			}
		} );
	} );
} );
